import { helpers } from '../store/helpers';

export default {
	methods: {
		loadTheme() {
			let team = Spark.state.currentTeam,
				themeconfig = this.$store.state.activePlan.name === 'Pro' || this.onGenericTrial ? JSON.parse(team.configuration) : {};

			themeconfig.dark = (themeconfig.dark ? true : false);
			themeconfig.darks = (themeconfig.darks ? themeconfig.darks : {});
			themeconfig.themes = (themeconfig.themes ? themeconfig.themes : {});
			themeconfig.darks.dark = Object.assign({}, helpers.defaults.themedarks.dark, (themeconfig.darks.dark ? themeconfig.darks.dark : {}));
			themeconfig.darks.light = Object.assign({}, helpers.defaults.themedarks.light, (themeconfig.darks.light ? themeconfig.darks.light : {}));
			themeconfig.themes.dark = Object.assign({}, helpers.defaults.theme.themes.dark, (themeconfig.themes.dark ? themeconfig.themes.dark : {}));
			themeconfig.themes.light = Object.assign({}, helpers.defaults.theme.themes.light, (themeconfig.themes.light ? themeconfig.themes.light : {}));

			this.$store.dispatch('set', {
				name: 'themedarks',
				value: themeconfig.darks
			});

			delete themeconfig.darks;

			this.$store.dispatch('set', {
				name: 'theme',
				value: themeconfig
			});

			if(themeconfig.themes && themeconfig.themes.dark){
				for(let darkcolor in themeconfig.themes.dark){
					this.$vuetify.theme.themes.dark[darkcolor] = themeconfig.themes.dark[darkcolor];
				}
			}
			if(themeconfig.themes && themeconfig.themes.light){
				for(let lightcolor in themeconfig.themes.light){
					this.$vuetify.theme.themes.light[lightcolor] = themeconfig.themes.light[lightcolor];
				}
			}
			this.$vuetify.theme.dark = themeconfig.dark;
		}
	}
}
